var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 30",
    width: 17,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Staff") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 26,
    height: 24,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAYCAMAAADTXB33AAAAAXNSR0IB2cksfwAAAGBQTFRFAAAAn5+fo6OjpaWlpaWlpaWlpaWlpaWln5+fpaWlpaWlpqamp6eno6OjpaWlp6enpKSkpaWlpKSkn5+fpaWlo6OjpaWlpKSkpKSkpaWlpqampqampqampKSkoqKioqKi704zzgAAACB0Uk5TABBAMGD/z58gv99fIICvf6CQvzCwkO/vcG9Qj3DPYFCrHZKGAAABE0lEQVR4nG2S226DMAyG/YcyBcraal3LejHt/V9r2hDqNnbi2AAZOTFA9UUc5YvtP3ZAxgB0yq+GDWpzpFeOlshHQRQBld90I+JM6Bvht1qjnirp0K6wabtes4b/WoSVJRR9ahegtIh5Dt1mxtXCov2PQ9t37Q44u1pxZtGNKRryzKGHD0P80sSW+gpsck1YripvCqMGVpqPdp1K1Q26Qzrpxr9FqDpJV9HEriBPSjkiFuf2xbV5ClPNHxDjYow4JpKicnMR8cuA1pdZAaGSRaw6JODbbIro+Gr6snvDOBBnrdbAvD0e0wU6PWsXf8FfatdjHGYWIBQLZLqPIMRTPZehpnnKqZE9hm82E9+pCEG4T/4ALRFVYtpSaLkAAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Background",
    href: "#img1",
    x: 3,
    y: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff);
export default __webpack_public_path__ + "static/media/Staff.2deb33ec9e109c65401a6833512babab.svg";
export { ForwardRef as ReactComponent };